module.exports = {
	"root": "findify-components-common--image",
	"thumbnail": "findify-components-common--image__thumbnail",
	"croppedRoot": "findify-components-common--image__croppedRoot",
	"loading": "findify-components-common--image__loading"
};